import React from 'react';

const PRIVACY_PDF_URL =
  'https://universaldrive.nl/wp-content/uploads/2020/07/Privacyverklaring-Universaldrive.pdf';

function Privacy() {
  return (
    <main style={{ margin: '0', padding: '0', marginTop: '56px' }}>
      <div
        style={{
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          overflow: 'hidden',
          minHeight: 600,
          background: '#fafafa',
          width: '100vw',
          marginLeft: 'calc(-50vw + 50%)',
        }}
      >
        {/* Try to embed the PDF. The browser will show its native PDF viewer if supported. */}
        <iframe
          title="Privacyverklaring UniversalDrive"
          src={PRIVACY_PDF_URL}
          style={{ width: '100vw', height: 800, border: 'none', display: 'block' }}
          sandbox="allow-scripts allow-same-origin"
        />
      </div>

      <noscript>
        <p>
          JavaScript is uitgeschakeld. Je kunt de privacyverklaring bekijken via deze link:{' '}
          <a href={PRIVACY_PDF_URL} target="_blank" rel="noreferrer">
            Privacyverklaring (PDF)
          </a>
        </p>
      </noscript>
    </main>
  );
}

export default Privacy;
